import http from '../../services/http.service';
import resources from '../../config/api/resources';

export default {
  getCampaigns(startRange, endRange, params) {
    return http.get(`${resources.CAMPAIGNS}/${startRange};${endRange}`, {
      params
    });
  },

  getCampaignById(eventId, params) {
    return http.get(`${resources.CAMPAIGNS}/${eventId}`, { params });
  }
};
